/* -----------------------------------------------------------------------------
 * User SM Getters
 *
 * @description - Getters of User SM. Check ./README.md for more info.
 * -----------------------------------------------------------------------------
 */

export default {

  /**
   * Get user data
   */
  getUserData (state) {
    return state.user
  },

  /**
   * Get portfolio data
   */
  getPortfolioData (state) {
    return state.portfolio
  },

  /**
   * Get risk range title
   */
  getRiskRangeTitle (state) {
    const profiles = state.portfolio.riskProfiles
    return function (r) {
      if (!profiles || profiles.length === 0) return '' // fallback
      for (let i = 0; i < profiles.length; i++) {
        if (profiles[i].risk_ranges.length < 2) {
          if (r === profiles[i].risk_ranges[0]) {
            return profiles[i].title
          }
        } else {
          if (r >= profiles[i].risk_ranges[0] && r <= profiles[i].risk_ranges[1]) {
            return profiles[i].title
          }
        }
      }
      return ''
    }
  },
  /**
   * Get sms data
   */
  getSMSData (state) {
    return state.sms
  },

  /**
   * Get terms of use
   */
  getTermsOfUse (state) {
    if (!state.terms) return ''
    if ('termsOfUse' in state.terms) return state.terms.termsOfUse
    return ''
  },

  /**
   * Get privacy policy
   */
  getPrivacyPolicy (state) {
    if (!state.terms) return ''
    if ('privacyPolicy' in state.terms) return state.terms.privacyPolicy
    return ''
  },

  /**
   * Get user agreements
   */
  getUserAgreements (state) {
    if (!state.terms) return ''
    if ('userAgreements' in state.terms) return state.terms.userAgreements
    return ''
  },

  // -------------------------------------------------------------------- [POLL]

  /**
   * Get poll answers
   */
  getPollAnswers: state => state.poll.answers,

  /**
   * Get poll complete status
   */
  getPollCompleteStatus (state) {
    return state.poll.answers.every(answer => {
      return answer !== null
    })
  },

  /**
   * Get poll questions models
   */
  getPollQuestionsModels (state) {
    const poll = state.poll.prototype
    if (!poll) return [] // fallback
    return poll.map(({ text, answers, id }, idx) => {
      const questionID = id
      return {
        text, // question text
        id, // question id
        idx, // question index
        answers: answers.map(({ text, id }) => {
          return {
            text, // answer label
            id, // answer id
            value: {
              question_id: questionID,
              answer_id: id
            }
          }
        })
      }
    })
  },

  // ---------------------------------------------------------------- [Tracking]
  getTracking (state) {
    return state.tracking
  }

}
